import { Language } from "../../../utils/dictionary";

export type IntegrationCategory = "chat_channels" | "sales_payments";

export type IntegrationType =
  | "dropi"
  | "mastershop"
  | "mercadopago"
  | "stripe"
  | "shopify"
  | "whatsapp"
  | "messenger"
  | "instagram"
  | "confio";

export type ChatChannelType = "whatsapp" | "messenger" | "instagram";

export interface IntegrationUIConfig {
  type: IntegrationType;
  name: string;
  logoSrc: string;
  bgColor: string;
  category: IntegrationCategory;
}

export interface IntegrationCategoryConfig {
  id: IntegrationCategory;
  label: Record<Language, string>;
  integrationTypes: IntegrationType[];
}

export const INTEGRATIONS_UI_CONFIG: Record<IntegrationType, IntegrationUIConfig> = {
  dropi: {
    type: "dropi",
    name: "Dropi",
    logoSrc: "https://fluxi.s3.amazonaws.com/prod/assets/integrations/logo/dropi-logo-v3",
    bgColor: "bg-[#EB6F2D]",
    category: "sales_payments",
  },
  mastershop: {
    type: "mastershop",
    name: "Mastershop",
    logoSrc: "https://fluxi.s3.amazonaws.com/prod/assets/integrations/logo/mastershop-logo-v2",
    bgColor: "bg-[#7CFF4F]",
    category: "sales_payments",
  },
  mercadopago: {
    type: "mercadopago",
    name: "Mercado Pago",
    logoSrc:
      "https://http2.mlstatic.com/frontend-assets/mp-web-navigation/ui-navigation/6.7.73/mercadopago/logo__large@2x.png",
    bgColor: "bg-transparent",
    category: "sales_payments",
  },
  stripe: {
    type: "stripe",
    name: "Stripe",
    logoSrc: "https://fluxi.s3.amazonaws.com/prod/assets/integrations/logo/stripe-logo-v5",
    bgColor: "bg-[#625BF6]",
    category: "sales_payments",
  },
  shopify: {
    type: "shopify",
    name: "Shopify",
    logoSrc: "https://cdn.shopify.com/assets/images/logos/shopify-bag.png",
    bgColor: "bg-[#95BF47]",
    category: "sales_payments",
  },
  whatsapp: {
    type: "whatsapp",
    name: "WhatsApp Business",
    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png",
    bgColor: "bg-[#25D366]",
    category: "chat_channels",
  },
  messenger: {
    type: "messenger",
    name: "Messenger",
    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/b/be/Facebook_Messenger_logo_2020.svg",
    bgColor: "bg-[#0084FF]",
    category: "chat_channels",
  },
  instagram: {
    type: "instagram",
    name: "Instagram",
    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg",
    bgColor: "bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#FCAF45]",
    category: "chat_channels",
  },
  confio: {
    type: "confio",
    name: "Confío",
    logoSrc: "https://fluxi.s3.amazonaws.com/prod/assets/integrations/logo/confio-logo-v2",
    bgColor: "bg-transparent",
    category: "sales_payments",
  },
};

export const CHAT_CHANNEL_TYPES: ChatChannelType[] = ["whatsapp", "messenger", "instagram"];

export const INTEGRATION_CATEGORIES: IntegrationCategoryConfig[] = [
  {
    id: "chat_channels",
    label: {
      [Language.SPANISH]: "Canales de chat",
      [Language.ENGLISH]: "Chat channels",
      [Language.PORTUGUESE]: "Canais de chat",
    },
    integrationTypes: ["whatsapp", "messenger", "instagram"],
  },
  {
    id: "sales_payments",
    label: {
      [Language.SPANISH]: "Ventas y pagos",
      [Language.ENGLISH]: "Sales & payments",
      [Language.PORTUGUESE]: "Vendas e pagamentos",
    },
    // Orden de presentación: logística primero (MasterShop, Dropi, Shopify) y luego pagos.
    integrationTypes: ["mastershop", "dropi", "shopify", "mercadopago", "stripe", "confio"],
  },
];
